import { themeVars } from '@styles/themes.css';
import { style } from '@vanilla-extract/css';

export const presentation = style({
  position: 'relative',
  backgroundSize: '100% 100%',
  backgroundPosition: '0 0',
  backgroundImage: `radial-gradient(75% 75% at -22% 0%, ${themeVars.brandColor.presentation.background.gradientStart} 0%, ${themeVars.brandColor.presentation.background.gradientEnd} 100%)`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '1rem',
  padding: '2rem 1.25rem',
  '@media': {
    'screen and (min-width: 64em)': { padding: '1.25rem 3.75rem' },
  },
});

export const arrowBackground = style({
  position: 'absolute',
  left: 0,
  width: '80%',
  maxHeight: '80%',
  top: '50%',
  transform: 'translate(0, -50%)',
});

export const leftColumnLayoutDiv = style({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
});

export const logoHorizontalDiv = style({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '0.75rem',
  '@media': {
    'screen and (min-width: 64em)': { padding: 0 },
  },
});

export const fullWidthDiv = style({
  width: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '3rem',
});

export const reassuranceText = style({
  fontFamily: themeVars.font.Magenos,
  fontSize: '1.125rem',
  fontWeight: 900,
});
